export const DASHBOARD_ENDPOINTS = {
  KPI_SUMMARY: "/dashboard/v3/kpi-summary",
  ASSIGNED_METRICS_COMPLETION: "/dashboard/v3/assigned-metrics/completion",
  ASSIGNED_METRICS_TARGET_SETUP: "/dashboard/v3/assigned-metrics/target-setup",
  ASSIGNED_METRICS_SUMMARY: "/dashboard/v3/assigned-metrics/summary",
  ASSIGNED_METRICS_CATEGORIES: "/dashboard/v3/assigned-metrics/categories",
  ASSIGNED_METRICS_LIST: "/dashboard/v3/assigned-metrics/list",
  ASSIGNED_METRICS_DETAIL: "/dashboard/v3/assigned-metrics/detail",
  METRIC_OVERVIEW: "/dashboard/v3/metric-overview",
  METRIC_DETAIL: "/dashboard/v3/metric-overview/detail",
  ORGANIZATION_OVERVIEW: "/dashboard/v3/organization-overview",
  ORGANIZATION_DETAIL: "/dashboard/v3/organization-overview/detail",
  CONSOLIDATED_METRIC_OVERVIEW: "/dashboard/v3/consolidated/metric-overview",
  CONSOLIDATED_METRIC_DETAIL:
    "/dashboard/v3/consolidated/metric-overview/detail",
  CONSOLIDATED_ORGANIZATION_DETAIL:
    "/dashboard/v3/consolidated/organization-overview/detail",
  ESG_DATA_TABLE: "/dashboard/v3/esg-data-table",
  E_CHARTS: "/dashboard/v3/e-charts",
  E_CHARTS_TOTALS: "/dashboard/v3/e-charts/totals",
  EMISSIONS_BREAKDOWN: "/dashboard/v3/emissions/breakdown",
};
